export * from "./contracts";
export * from "./Decorators";
export * from "./helpers/QueryBuilder";
export * from "./App";
export let mocks = {};
if (process.env.NODE_ENV === "development") {
    mocks = require("./mocks");
    const { SportsRangeConnection, EventsConnection } = require("./ExampleConnections");
    function demo() {
        window["__sbDataLayer__demo__Sports_1"] =
            new SportsRangeConnection("__sbDataLayer__demo__Sports_1");
        window["__sbDataLayer__demo__Events_1"] =
            new EventsConnection("__sbDataLayer__demo__Events_1");
        setTimeout(() => {
            window["__sbDataLayer__demo__Events_2"] =
                new EventsConnection("__sbDataLayer__demo__Events_2");
        }, 2000);
    }
    function dropAll() {
        window["__sbDataLayer__demo__Sports_1"].query = undefined;
        window["__sbDataLayer__demo__Events_1"].query = undefined;
        window["__sbDataLayer__demo__Events_2"].query = undefined;
    }
    module.exports = Object.assign(Object.assign({}, module.exports), { demo,
        dropAll });
}
//# sourceMappingURL=index.js.map